import { render, staticRenderFns } from "./CardProductSale.vue?vue&type=template&id=e0e83992&scoped=true&"
import script from "./CardProductSale.vue?vue&type=script&lang=js&"
export * from "./CardProductSale.vue?vue&type=script&lang=js&"
import style0 from "./CardProductSale.vue?vue&type=style&index=0&id=e0e83992&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0e83992",
  null
  
)

export default component.exports